export default "__VITE_ASSET__BwvG7YZf__"